import React, { ReactNode } from 'react';
import ClearFilter from '../clear-filter';
import TogglePropertyColumn from '../toggle-property-column';
import * as S from './styles';

type Props = {
  property?: string;
  title: string;
  showTitle?: boolean;
  children: ReactNode;
};

const Section = ({ property, title, showTitle, children }: Props) => {
  return (
    <section data-test="FilterSection">
      <S.SectionHeader>
        {showTitle && (
          <S.SectionTitle data-test="FilterSectionTitle">
            {title}
          </S.SectionTitle>
        )}

        <S.SectionActions>
          <S.SectionAction>
            <ClearFilter property={property} />
          </S.SectionAction>
          {property && (
            <S.SectionAction>
              <TogglePropertyColumn propertyId={property} />
            </S.SectionAction>
          )}
        </S.SectionActions>
      </S.SectionHeader>

      {children}
    </section>
  );
};

export default Section;
